const PARAMS_MAP = {
  top: {
    dx: 0,
    dy: -1,
    distance: 120
  },
  right: {
    dx: 1,
    dy: 0,
    distance: 120
  },
  bottom: {
    dx: 0,
    dy: 1,
    distance: 120
  },
  left: {
    dx: -1,
    dy: 0,
    distance: 120
  }
};
export default function create(options) {
  const {
    direction = 'left'
  } = options.namedEffect;
  const fromParams = PARAMS_MAP[direction];
  const transformX = fromParams.dx * fromParams.distance;
  const transformY = fromParams.dy * fromParams.distance;
  return [{
    ...options,
    easing: 'sineInOut',
    duration: options.duration,
    keyframes: [{
      opacity: 0,
      translate: `${transformX}px ${transformY}px`
    }, {
      opacity: 'var(--comp-opacity, 1)',
      translate: `0px 0px`
    }]
  }];
  /*
   *
   * * @keyframes <name> {
   *   from {
   *     opacity: 0;
   *     translate: <transformX>px <transformY>px 0px
   *   }
   *   to {
   *     opacity: 1;
   *     translate: 0px 0px
   *   }
   * }
   *
   * #target {
   *   animation: <name> <duration> <delay> <easing> sineInOut backwards;
   * }
   */
}
//# sourceMappingURL=FloatIn.js.map